export default __webpack_public_path__ + "static/media/camera.88931351.svg";